import { axiosInstance } from './api'
import type { AvailableSlot } from '@/types'

export interface CheckRescheduleResponse {
  hasExisting: boolean
  leadId:      string | null
  existingSlotLabel: string
}

export async function checkHasSchedule(domainId: string): Promise<boolean> {
  try {
    const { data } = await axiosInstance.get<{ hasActiveSchedule: boolean }>(
      `/api/domains/${domainId}/schedule`
    )
    return data.hasActiveSchedule
  } catch {
    return false
  }
}

export async function getAvailableSlots(domainId: string): Promise<AvailableSlot[]> {
  const { data } = await axiosInstance.get<{ slots: AvailableSlot[] }>(
    `/api/domains/${domainId}/available-slots`
  )
  return data.slots ?? []
}

export async function checkReschedule(
  domainId: string,
  email: string,
  phone: string,
): Promise<CheckRescheduleResponse> {
  const { data } = await axiosInstance.get<CheckRescheduleResponse>(
    `/api/domains/${domainId}/appointment-leads/check-reschedule`,
    { params: { email, phone } }
  )
  return data
}

export async function rescheduleAppointment(
  domainId: string,
  leadId: string,
  customerEmail: string,
  customerWhatsApp: string,
  appointmentDate: string,
  slotStart: string,
  slotEnd: string,
): Promise<void> {
  await axiosInstance.put(
    `/api/domains/${domainId}/appointment-leads/${leadId}/reschedule`,
    { customerEmail, customerWhatsApp, appointmentDate, slotStart, slotEnd }
  )
}

export async function bookAppointment(
  domainId: string,
  customerName: string,
  customerWhatsApp: string,
  customerEmail: string,
  appointmentDate: string,
  slotStart: string,
  slotEnd: string,
  // Links the booking to the chat it came from, so the client's email can include
  // what the customer actually asked the AI before booking.
  sessionId?: string | null,
): Promise<void> {
  await axiosInstance.post(`/api/domains/${domainId}/appointment-leads`, {
    customerName,
    customerWhatsApp,
    customerEmail,
    appointmentDate,
    slotStart,
    slotEnd,
    sessionId: sessionId ?? null,
  })
}
